module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero2.png?e9a75dfa";